<template>
  <section class="top-hero">
    <v-container fluid fill-height class="top-hero__content">
      <v-row>
        <v-col class="top-hero__content-text">
          <div class="catch_copy">
            <p>小規模資本でも「戦える」<br>オンリーワンの自社ネットショップ構築/運用を<br>リーズナブルに実現する</p>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <div class="index">
      <h2>お客様のEC運営における課題</h2>
      <p class="explanation">
      </p>
      <div class="case-study">
        <span class="case-study-title">課題１ </span>
        <p class="explanation">
          <span class="emphasis">SaaS型ECだと実現できない自社の独自性をより出したいが予算が足りない...</span
          ><br /><br />
          ShopifyやBaseなどSaaS型ECで顧客との接点はできたが、追加の要望や自社の独自性を出して更なる顧客接点や購入数を増やしたい。<br />
          しかし、予算が足りないことにより、事業拡張や新しいことに踏み出せない
        </p>
      </div>
      <div class="case-study">
        <span class="case-study-title">課題2 </span>
        <p class="explanation">
          <span class="emphasis"
            >自社でECカートシステムを導入しているが、老朽化してアップデートしたいタイミング</span
          ><br /><br />
            無料のECカートシステムや開発ベンダーに製作してもらったECシステムを導入しているが、仕組みが古く現場運用負担が増加、<br>
            老朽化によるセキュリティリスクの発生による事業活動への影響
          <br />
        </p>
      </div>
      <div class="case-study">
        <span class="case-study-title">課題3 </span>
        <p class="explanation">
          <span class="emphasis"
            >ECを用いて自社業務を運営しているが、お客様のリピートを得られない</span
          ><br /><br />
          お客様からリピートを得られない原因は、「お客様がECシステムに使いづらさを感じている」/「魅力的な特典がない」/「商品の魅力が伝わっていない」など多岐にわたります
          <br />
        </p>
      </div>
    </div>
    <div class="index">
      <h2>解決方法(SOLUTIONS)</h2>
      <b>私たちは業界の常識に挑戦するゲリラ的開発を通して、小規模事業者をECビジネスで勝利させる応援部隊です！</b>
      <div class="case-study">
        <span class="case-study-title">ECカウンセリング</span>
        <p class="explanation">
          <span class="emphasis"
            >お客様のEC活用現場が求める価値あるシステムは何かを問い、本来あるべきシステムや仕組みをご提案します</span
          ><br /><br />
          <span>
          <ul>
            <li>本当に御社にとって予算をかけてまで開発すべきシステムなのか？</li>
            <li>現場の運用をしっかり汲んで、売上に直結するシステムなのか？</li>
            <li>大きな事業構想をシステムで実現しようとしているが、地に足がついた設計になっているか？</li>
          </ul>
          </span>
          <br />
          <span class="emphasis"
            >ゲリラ戦においては、戦地における無駄な行動や方向性のミスは命取りです。<br>既存のEC事業のアップデートや新規EC事業に立ち上げにおいても、<br/>
            同じことが言え、本来お客様がEC導入によって生み出したい価値を突き詰めた支援をいたします。</span>
          <br /><br />
            ＜まずは無料のECサイト構築コンサルをお申し込みください＞<br /><br />
          他社とは違う自社サイトをリーズナブルに実現したい企業様、担当者様、まずは気軽にご連絡ください。<br />
          専業のECコンサルに依頼すれば数万円〜数十万円する「勝てる」ECサイト構築の流れについてお客様がご納得するまで、<br />
          ECサイト構築のエキスパートがご相談を承ります。
           <br /><br /><br /> 
          <span class="btn-positon">
            <a href="https://forms.gle/2ee784g8o1j61e7c9" class="btn"
              >ご相談はこちら</a
            >
          </span>
        </p>
        <br /><br />
      </div>
      <div class="case-study">
        <span class="case-study-title">ECソリューション</span>
        <p class="explanation">
          <span class="emphasis"
            >ECビジネスで柔軟に事業展開するための独自パッケージを提供いたします</span
          ><br /><br />
           世の中に、たくさんのECパッケージやSaaS型のサービスは存在しますが、お客様の現場独自の業務に合わせたカスタムECプロダクトを提供いたします。
           特徴は、「柔軟な機能拡張性」、「Web3.0時代に適応した仕組み」、「使いやすいUIの追求」となります。
          <br />
        
          <br /><br /><br />
          <span class="btn-positon">
            <a href="https://forms.gle/2ee784g8o1j61e7c9" class="btn"
              >ご相談はこちら</a
            >
          </span>
        </p>
        <br /><br />
      </div>
    </div>
  </section>
</template>

<script>
import AssetsImage from "@/assets/logo.png";

export default {
  name: "AppHeader",

  data() {
    return {
      assetsImage: AssetsImage,
    };
  },
};
</script>

<style  lang="scss" scoped>
.top-hero__content {
  background-image: url("../assets/img/guerrilla-cart.png");
  background-color: rgba(255, 255, 255, 0.8);
  background-blend-mode: lighten;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  width: 100%;

  &-text {
    color: black;
    text-align: center;
    font-weight: bold;
    font-family: "メイリオ", "Meiryo", sans-serif;
    font-size: 4vw;
    height: 20vh;
  }

  .catch_copy {
    padding-top: 1rem;
  }

  @include display_pc {
    height: 55vh;
    font-size: 5vw;
  }
}

.box_info {
  margin-left: auto;
  margin-right: auto;
  padding-top: 10rem;
}
.box_srcollbar {
  overflow: auto;
  width: 100%;
  height: 40px;
  padding: 5px;
  border: 1px solid #000;
  background-color: #f9f9f9;
  color: #000;
  font-size: 20px;
  text-align: center;
}
.box_title {
  border: 1px solid #000;
  text-align: center;
  padding: 5px;
  width: 100%;
  font-weight: bold;
  font-size: 20px;
  background-color: #dcdcdc;
  color: #000;
}
h2 {
  position: relative;
  padding: 0.25em 0;
}
h2:after {
  content: "";
  display: block;
  height: 4px;
  background: -webkit-linear-gradient(to right, rgb(66, 64, 64), transparent);
  background: linear-gradient(to right, rgb(66, 64, 64), transparent);
}
.index {
  margin: 20px;
  padding: 20px;
}
.explanation {
  font-weight: bold;
  letter-spacing: 0.12em;
  font-size: 1rem;
}

.explanation .emphasis {
  font-size: 1.5rem;
  font-family: Times New Roman, "メイリオ";
}
.case-study {
  position: relative;
  margin: 2em 0;
  padding: 0.5em 1em;
  border: solid 3px #7d7f81;
  border-radius: 8px;
}

.case-study .case-study-title {
  position: absolute;
  display: inline-block;
  top: -13px;
  left: 10px;
  padding: 0 9px;
  line-height: 1;
  font-size: 19px;
  background: #fff;
  color: #7d7f81;
  font-weight: bold;
}
.case-study p {
  margin: 0;
  padding: 0;
}

.case-study ul, ol {
  background: #fcfcfc;/*背景色*/
  padding: 0.5em 0.5em 0.5em 2em;/*ボックス内の余白*/
  border: solid 3px gray;/*線の種類 太さ 色*/
}

.case-study ul li, ol li {
  line-height: 1.5; /*文の行高*/
  padding: 0.5em 0; /*前後の文との余白*/
}

.btn-positon {
  text-align: center;
}

.btn-positon .btn {
  color: #ffffff;
  font-size: 24px;
  border-radius: 30px;
  font-weight: bold;
  background-color: #000;
  padding: 20px;
}

.btn-positon .btn:hover {
  opacity: 0.5;
}

.btn-positon a {
  text-decoration: none;
}
</style>